<template>
  <div class="common-pay"></div>
</template>
<script>
import _wx from "../../static/js/chelun-wx-1.1.js";
import _kjz from "../../static/js/chelun-kjz.js";
import { payUrl, hostUrl, OPENID, cjjlPay, OPENIDNEW } from "../http/env.js";
import { pay } from "@/http/api";

export default {
  data() {
    return {
      openid: "",
      query: "",
      student_id: "",
      soft_sn: "",
      pay_order: {},
      pay_type: "",
      paySubmit: {
        c: "order",
        v: "pay2",
        serial_number: this.$route.query.serial_number || "",
        channel: "",
        callback_url: this.$route.query.callback_url
          ? decodeURIComponent(this.$route.query.callback_url)
          : ""
      }
    };
  },
  methods: {
    payHandle() {
      pay({ ...this.paySubmit }).then(res => {
        console.log(res);
        if (_wx.isWx) {
          if (this.$route.query.payFrom) {
            let path = cjjlPay + "/2017/superCoach/pay_wx.html";
            let i,
              url = "";
            for (i in res.data.order_param) {
              url += "&" + i + "=" + res.data.order_param[i];
            }
            window.location.href = path + url.replace(/./, "?");
          } else {
            _wx.pay(res.data.order_param, () => {
              window.location.href = res.data.order_param.callback_url;
            });
          }
        } else {
          window.location.href = res.data.url;
        }
      });
    },
    init() {
      this.pay_type = sessionStorage.pay_type;
      if (_wx.isWx) {
        this.paySubmit.openid = this.$route.query.openid || "";
        if (!this.paySubmit.openid) {
          this.getOpenId(window.location.href);
          return false
        }
      }
      this.paySubmit.channel = _wx.isWx ? "weixin_mp" : "alipay";
      this.payHandle();
    },
    getOpenId() {
      var url = window.location.href;
      var href = `${OPENID}/wx/auth/filter?redirect=` + encodeURIComponent(url);
      window.location.href = href;
    },
  },
  created() {
    console.log("routeOption", this.$route);
    this.init();
    window["CHELUN_SHOW_OPTION_MENU"] = 0;
    _wx.hideMenus([
      "menuItem:share:appMessage",
      "menuItem:share:timeline",
      "menuItem:share:qq",
      "menuItem:share:weiboApp",
      "menuItem:favorite",
      "menuItem:share:facebook",
      "menuItem:share:QZone"
    ]);
  }
};
</script>

<style lang="scss" scoped>
.common-pay {
  font-size: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common-pay.vue